import { render, staticRenderFns } from "./VModalRemarkRejection.vue?vue&type=template&id=0efd3151&"
import script from "./VModalRemarkRejection.vue?vue&type=script&lang=ts&"
export * from "./VModalRemarkRejection.vue?vue&type=script&lang=ts&"
import style0 from "./VModalRemarkRejection.vue?vue&type=style&index=0&id=0efd3151&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports